import { createContext, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

// Shares "is the Tags quick-filter active" from the Records view up to the layout
// banner. useBanner is pathname-only and the filter state lives in the view, so a
// small context is the reactive bridge. Default false so consumers outside the
// provider (e.g. auth-page useBanner calls) never crash.
const TagsFilterContext = createContext({ tagsFilterActive: false, setTagsFilterActive: () => {} });

export function TagsFilterProvider({ children }) {
  const [tagsFilterActive, setTagsFilterActive] = useState(false);
  const value = useMemo(() => ({ tagsFilterActive, setTagsFilterActive }), [tagsFilterActive]);
  return <TagsFilterContext.Provider value={value}>{children}</TagsFilterContext.Provider>;
}

TagsFilterProvider.propTypes = {
  children: PropTypes.node,
};

export const useTagsFilter = () => useContext(TagsFilterContext);

export default TagsFilterContext;
